module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAKCAYAAABrGwT5AAAAAXNSR0IArs4c6QAAAU9JREFUKFOVkk1LAnEQxp/5u2sYHXrDzNJI6RQGJaZ0ECKIPkcHraQPU0RJEHTp1Afo6iFSD9EbVhJFSEouZIVK6bo7sfaClUHOceZ5hpnfDKHFGJ/P2NvazTssRIha8fqXHwaJ1RgAN4DYv81jC/dWiwlxIrgAXDDVZsm3pNhMQluVNEt4f6Pzsdkk7xo9AWAIwHUF1eDRmjNHgUh+D8RzYJyqajl4uOl+bmwwGbnrIZLOCOhnprTQqjPxqCNraMgfVkZI1o097MycrpRfA8fbw09G0RvK9cpmcWLUAJyLGqYPojbls3l9Z99i3iWEHiMiBzNuaqruMQutiyX5EkCHkYNEU8mVvnzjVF/A6iR1NQHCAMAZgLoNI4ArelED8S1H4SePb7S9oaxTkk1JItjqQsZtkYUntW4tNQP561QfZJPMXCwphYnU7mj1r194A+ide644pOK7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/cancel.png
// module id = yjfb
// module chunks = 44